import { BrowserRouter as Router, Routes, Route } from "react-router";
import SignIn from "./pages/AuthPages/SignIn";
import NotFound from "./pages/OtherPage/NotFound";
import { useAuth } from "@/context/AuthContext";
import { TenancyAuthProvider } from "@/context/TenancyAuthContext";
import { Rol } from "@/types/roles";

import PrivateRoute from "@/components/auth/PrivateRoute";
import TenancyPrivateRoute from "@/components/tenancy/TenancyPrivateRoute";

import AppLayout from "./layout/AppLayout";
import { ScrollToTop } from "./components/common/ScrollToTop";
import UserProfiles from "./pages/UserProfiles";
import Home from "./pages/Dashboard/Home";
import LandingPage from "./pages/AuthPages/landingpage";

import ListarSucursales from "./views/multiempresa/sucursales";
import CreateSucursal from "./views/multiempresa/sucursales/create";
import UpdateSucursal from "./views/multiempresa/sucursales/update";
import VerSucursal from "./views/multiempresa/sucursales/view";

import ListarConfiguraciones from "./views/multiempresa/configuracion_empresas";
import CreateConfiguracion from "./views/multiempresa/configuracion_empresas/create";
import UpdateConfiguracion from "./views/multiempresa/configuracion_empresas/update";
import VerConfiguracion from "./views/multiempresa/configuracion_empresas/view";

import ListarUsuarios from "./views/seguridad_accesos/usuarios";
import CreateUsuario from "./views/seguridad_accesos/usuarios/create";
import UpdateUsuario from "./views/seguridad_accesos/usuarios/update";
import VerUsuario from "./views/seguridad_accesos/usuarios/view";

import ListarSesiones from "./views/seguridad_accesos/sesiones";
import VerSesion from "./views/seguridad_accesos/sesiones/view";

import CreateProyectos from "./views/proyectos/create";
import UpdateProyecto from "./views/proyectos/update";
import VerProyecto from "./views/proyectos/view";
import ListarProyectos from "./views/proyectos";
import HistorialActividades from "@/views/proyectos/tabs/historial";

import SurveyCreate from "./views/survey/create";
import SurveyList from "./views/survey";
import SurveyUpdate from "./views/survey/update";
import SurveyMap from "./views/survey/map";
import SurveyResponse from "./views/survey/response";

import MobileTareaProyecto from "./mobile/tareas";
import MobileEncuestas from "./mobile/encuestas";
import MasiveUsuarios from "./views/seguridad_accesos/usuarios/masive";
import SurveyDashboard from "./views/survey/dashboard";
import SurveyTemplate from "./views/survey/template";
import TenancyDashboard from "./views/tenancy/TenancyDashboard";
import TenancyLogin from "./views/tenancy/TenancyLogin";

export default function App() {
  const { user, isMobileApp } = useAuth();
  const userRol =
    user?.rol !== undefined && user?.rol !== null
      ? Number(user.rol)
      : undefined;

  return (
    <TenancyAuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
            {/* ===== RUTAS TENANCY - SIN SIDEBAR, ELEGANTE ===== */}
            {/* Login del master único */}
            <Route path="/tenancy/login" element={<TenancyLogin />} />
            {/* Dashboard master - con su propio layout con botón cerrar sesión */}
            <Route
              path="/tenancy"
              element={
                <TenancyPrivateRoute>
                  <TenancyDashboard />
                </TenancyPrivateRoute>
              }
            />

            {/* ===== RUTAS NORMALES DE EMPRESAS - CON SIDEBAR ===== */}
            <Route
              element={
                <PrivateRoute>
                  <AppLayout />
                </PrivateRoute>
              }
            >
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/multiempresa/sucursales"
                  element={<ListarSucursales />}
                />
              )}
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/multiempresa/sucursales/create"
                  element={<CreateSucursal />}
                />
              )}
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/multiempresa/sucursales/update/:id"
                  element={<UpdateSucursal />}
                />
              )}
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/multiempresa/sucursales/ver/:id"
                  element={<VerSucursal />}
                />
              )}

              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/multiempresa/configuracion_empresas"
                  element={<ListarConfiguraciones />}
                />
              )}
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/multiempresa/configuracion_empresas/create"
                  element={<CreateConfiguracion />}
                />
              )}
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/multiempresa/configuracion_empresas/update/:id"
                  element={<UpdateConfiguracion />}
                />
              )}
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/multiempresa/configuracion_empresas/ver/:id"
                  element={<VerConfiguracion />}
                />
              )}

              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE) && (
                <Route
                  path="/seguridad_accesos/usuarios"
                  element={<ListarUsuarios />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE) && (
                <Route
                  path="/seguridad_accesos/usuarios/create"
                  element={<CreateUsuario />}
                />
              )}
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/seguridad_accesos/usuarios/masive"
                  element={<MasiveUsuarios />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE) && (
                <Route
                  path="/seguridad_accesos/usuarios/update/:id"
                  element={<UpdateUsuario />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE) && (
                <Route
                  path="/seguridad_accesos/usuarios/ver/:id"
                  element={<VerUsuario />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE) && (
                <Route
                  path="/seguridad_accesos/sesiones"
                  element={<ListarSesiones />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE) && (
                <Route
                  path="/seguridad_accesos/sesiones/ver/:id"
                  element={<VerSesion />}
                />
              )}

              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/gestion_proyectos/proyectos"
                  element={<ListarProyectos />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/gestion_proyectos/proyectos/create"
                  element={<CreateProyectos />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/gestion_proyectos/proyectos/update/:id"
                  element={<UpdateProyecto />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/gestion_proyectos/proyectos/ver/:id"
                  element={<VerProyecto />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE) && (
                <Route
                  path="/gestion_proyectos/actividades/historial"
                  element={<HistorialActividades />}
                />
              )}

              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/gestion_proyectos/survey/create"
                  element={<SurveyCreate />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/survey/dashboard/:id"
                  element={<SurveyDashboard />}
                />
              )}
              {userRol === Rol.ADMIN_EMPRESAS && (
                <Route
                  path="/survey/template/:id"
                  element={<SurveyTemplate />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/gestion_proyectos/survey/update/:id"
                  element={<SurveyUpdate />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/gestion_proyectos/survey/list"
                  element={<SurveyList />}
                />
              )}
              {(userRol === Rol.ADMIN_EMPRESAS ||
                userRol === Rol.SUPERVISOR ||
                userRol === Rol.ASISTENTE ||
                userRol === Rol.COLABORADOR) && (
                <Route
                  path="/gestion_proyectos/survey/map/:id?"
                  element={<SurveyMap />}
                />
              )}

              {isMobileApp && (
                <Route
                  path="/gestion_proyectos/tareas"
                  element={<MobileTareaProyecto />}
                />
              )}
              {isMobileApp && (
                <Route
                  path="/gestion_proyectos/encuestas"
                  element={<MobileEncuestas />}
                />
              )}

              <Route index path="/home" element={<Home />} />
              <Route path="/profile" element={<UserProfiles />} />
            </Route>

            {/* Públicas */}
            <Route path="/signin" element={<SignIn />} />
            <Route
              path="/survey/response/:tenant/:id"
              element={<SurveyResponse />}
            />
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </TenancyAuthProvider>
  );
}
